<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<div
	class="spinner"
	[ngClass]="[size]"
></div>
